//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import {cms_poster} from "@/api/cms";
import {file} from "@/api/server";
import editInline from "@/components/file/editInline.vue";
import {mapState } from "vuex";

export default {
    props:{
        classList:{
            type:Array,
            default:[], 
        },
        type:{
            type:String,
            default:'WEEKPLAN'
        }
    },
    data(){
        return{
            addForm:{
                visible:false,
                loading:false,
                id:null,//修改标记
                data:{
                    title:'',
                    content:'',
                    school_week:1,
                    class_ids:[],
                    file_ids:[],//文件id
                    summary:'',
                    type:this.type,
                    release:false,
                },
                rules: {
                    title: [{ required: true, message:'请输入标题', trigger: "blur" }],
                    school_week: [{ required: true, message: "请选择学周", trigger: "blur" }],
                    class_ids: [{ required: true, message:'请选择班级', trigger: "blur" }],
                },
            },
            file,
            typeList:{
                'WEEKPLAN':'周计划',
                'RECIPES':'食谱',
            },
            fileList:[],
            files:[],
            percentage:0,
            id:null,
        }
    },

    computed: {
        ...mapState("user", ["currentWeek"]),
    },

    components: {editInline},

    methods:{
        closeInLineEdit(){
            this.addForm.visible=true;
            this.get();
        },
        
        // 打开在线编辑
        preview(file){
            if(file.status&&file.status!='success'){this.$message({ message:"文件未上传，不能下载", type: "error" });return;}
            let item={path:file.path,name:file.name,wps_url:file.wps_path};
            if(file.wps_path){
                this.addForm.visible=false;
            }
            this.$refs.myEditInline.showWps(item);
        },

        ctnChange(content){
            this.addForm.data.content = content;
        },
        classChange(val){
            if(val.findIndex(e=>e==0)!=-1){
                this.addForm.data.class_ids=[0];
            }
            if(this.addForm.data.class_ids.length>0){
                this.$refs.noticeForm.validateField("class_ids");
            }
        },

        get(){
            if(!this.id){
                return 
            }
            this.addForm.loading=true;
            cms_poster.get({id:this.id}).then(res=>{
                this.addForm.loading=false;
                if(res.data){
                    let data=res.data;
                    this.addForm.id=data.id;
                    this.addForm.data.title=data.title;
                    this.addForm.data.school_week=data.school_week;
                    this.addForm.data.content=data.content;
                    this.addForm.data.class_ids=data.class_info?[data.class_info.class_id]:[0];
                    if(data.attachment&&data.attachment.length>0){
                        this.fileList=data.attachment;
                        this.fileList.forEach(e => {
                            e.uid=e.id;
                            e.url=e.path;
                        });
                        this.addForm.data.file_ids=this.fileList.map(r=>{return r.id});
                    }
                    this.files=[];
                }else{
                    this.$message({ message: '获取信息失败，请重试！', type: 'info'})
                }
            })
        },
        openVisible(id){
            this.id=id?id:null;
            this.addForm.visible=true;
            this.addForm.data.class_ids=[];
            this.addForm.data.school_week=this.currentWeek;
            if(this.type=='RECIPES'){
                this.addForm.data.class_ids=[0];
            }else if(this.classList&&this.classList.length>0){
                this.addForm.data.class_ids.push(this.classList[0].id);
            }
            this.get();
        },
        cancel(){
            this.addForm.visible=false;
            this.addForm.loading=false;
            this.addForm.id=null;
            this.addForm.data.title='';
            this.addForm.data.content='';
            this.addForm.data.school_week=this.currentWeek;
            this.addForm.data.release=false;
            this.files=[];
            this.fileList=[];
        },
        removeFile(file, fileList) {
            this.files.splice(this.files.findIndex(item => item.uid === file.uid), 1);
            const ret=this.addForm.data.file_ids.findIndex(item => item === file.uid);
            if(ret!=-1){
                this.addForm.data.file_ids.splice(ret, 1);
            }
        },
        onUploadFileSuccess(item){
            this.files.push(item.file);
            if(this.addForm.data.title==''&&this.files&&this.files.length>0){
                let ret=this.files[0].name.indexOf('.');
                if(ret!=-1){
                    this.addForm.data.title=this.files[0].name.substring(0,ret);
                }else{
                    this.addForm.data.title=this.files[0].name;
                }
            }
        },
        isTooLarge(file) {                 
            const isLt2M = file.size / 1024 / 1024 < 10
            if(!isLt2M) {
                this.$message({
                    message: '上传文件大小不能超过10MB!',
                    type: 'warning'
                });
            }
            return isLt2M
        },
        isUploadFiles(val){
            this.$refs.noticeForm.validate(valid => {
                if (valid) {
                    this.addForm.data.release=val==1?true:false;
                    // 上传附件
                    this.addForm.data.file_ids=this.addForm.id?this.addForm.data.file_ids:[];
                    if(!(this.files&&this.files.length>0)){
                        this.add();
                        return
                    }
                    let param = new FormData();  
                    this.files.forEach(v=>{
                        param.append("file[]", v);
                    })
                    this.addForm.loading=true;
                    let that=this;
                    axios.post(file.uploadUrl,param, {
                        //调用onProgress方法来显示进度条
                        onUploadProgress: progressEvent => {
                            this.percentage=(progressEvent.loaded / progressEvent.total * 100) | 0
                        }
                    }).then((res)=>{
                        if (res.data.data) {
                            res.data.data.forEach((v,n)=>{
                                that.addForm.data.file_ids.push(v.id);
                            });
                            that.add();
                        }else{
                            that.percentage=0;
                            that.addForm.loading=false;
                        }
                    }).catch((err)=>{})
                }
            }); 
        },
        add(){
            let param=JSON.parse(JSON.stringify(this.addForm.data));
            if(param.class_ids.findIndex(e=>e==0)!=-1){
                param.class_ids=[];
            }
            if(this.addForm.id){
                param.release=false;
                param=Object.assign(param,{id:this.addForm.id});
                param.class_id=param.class_ids[0]?param.class_ids[0]:null;
                delete param.class_ids
            }
            let promise=this.addForm.id?cms_poster.update(param):cms_poster.add(param);
            promise.then((res) => {
                this.addForm.loading = false;
                if (res.data) {
                    this.$message({ message:this.addForm.id?'编辑成功！':'添加成功!', type: 'success'});
                    this.$parent.toGetList();
                    this.cancel();
                }
            });   
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/plan/add.vue